module.exports = __webpack_public_path__ + "static/media/email-not-verified.79776e98.svg";